export default __webpack_public_path__ + "static/salary-helper-431353f4983b52abe04a12abdeec5224.svg";